import { render, staticRenderFns } from "./modern-region.vue?vue&type=template&id=1fff11bb&scoped=true&"
import script from "./modern-region.vue?vue&type=script&lang=js&"
export * from "./modern-region.vue?vue&type=script&lang=js&"
import style0 from "./modern-region.vue?vue&type=style&index=0&id=1fff11bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fff11bb",
  null
  
)

export default component.exports